import React, { useState, useEffect, useCallback } from "react";
import { Button } from "baseui/button";
import { FormControl } from "baseui/form-control";
import { Select } from "baseui/select";
import { Textarea } from "baseui/textarea";
import axios from "axios";

export const sections = [
  "roadtest",
  "exterior",
  "underhood",
  "interior",
  "complete",
];

const filteredOptions = ["Good", "Needs Attention"].map((option) => ({
  id: option,
  label: option,
}));

const apiUrl = process.env.REACT_APP_API_URL;

export function InitialInspectionForm({
  vehicleId,
  currentSection,
  setCurrentSection,
  handleSubmitClick,
  editObj,
  goingNext,
  onClose,
  // initPaused,
  lastInitId,
  setIsModalOpen,
  // steps,
  filteredSteps,
}) {
  const [chosenSection, setChosenSection] = useState(goingNext);

  //FETCHING STEPS, FILTERED STEPS
  // const [steps, setSteps] = useState([]);
  // const [filteredSteps, setFilteredSteps] = useState([]);

  // const fetchSteps = async () => {
  //   try {
  //     const response = await axios.get(`${apiUrl}/api/steps`);
  //     const sortedSteps = response.data.steps
  //       .map((step) => ({
  //         id: step.id,
  //         label: step.step_name,
  //       }))
  //       .sort((a, b) => a.id - b.id);

  //     // Leave off the last 4 steps
  //     // const stepsWithoutLast4Or0 = sortedSteps.slice(1, -12);
  //     const stepsWithoutLast4Or0 = sortedSteps
  //       .slice(1, -12)
  //       .concat(sortedSteps[20]);
  //     console.log("stepsWithoutLast4Or0", stepsWithoutLast4Or0);

  //     // Update the state with the new array
  //     setFilteredSteps(stepsWithoutLast4Or0);
  //     setSteps(sortedSteps);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };

  // console.log("steps", steps);
  // console.log("filteredSteps", filteredSteps);

  useEffect(() => {
    // Find the step that matches 'goingNext' and set it as the pre-selected value
    if (goingNext && filteredSteps.length > 0) {
      const selectedStep = filteredSteps.find((step) => step.id === goingNext);
      if (selectedStep) {
        setChosenSection([selectedStep]); // Set it as an array
      }
    }
  }, [goingNext, filteredSteps]);

  // useEffect(() => {
  //   if (steps.length === 0) {
  //     fetchSteps();
  //   }
  // }, [steps]);

  const fetchIncompleteInit = useCallback(async () => {
    try {
      // Make the API call with the provided initInspectId
      const response = await axios.get(
        `${apiUrl}/api/init_inspection/${lastInitId}`
      );

      // Set the retrieved data into state
      console.log("fetchIncompleteInit return obj: ", response.data[0]);
      //make it not include the [0] property, (id)
      setInitInspectForm(response.data[0]);

      // If lastInitId exists, clear the relevant notes field so user can enter new data
      if (lastInitId) {
        // Initialize the notes fields to blank based on the current section
        if (currentSection === "roadtest") {
          setInitInspectForm((prevForm) => ({
            ...prevForm,
            roadTest_notes: "",
          }));
        } else if (currentSection === "exterior") {
          setInitInspectForm((prevForm) => ({
            ...prevForm,
            exterior_notes: "",
          }));
        } else if (currentSection === "underhood") {
          setInitInspectForm((prevForm) => ({
            ...prevForm,
            underHood_notes: "",
          }));
        } else if (currentSection === "interior") {
          setInitInspectForm((prevForm) => ({
            ...prevForm,
            interior_notes: "",
          }));
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [apiUrl, lastInitId, currentSection]);

  //for VehicleUpdateForm, to pull
  useEffect(() => {
    if (lastInitId) {
      console.log("fetchIncompleteInit was triggered");
      fetchIncompleteInit();
    }
  }, [lastInitId, fetchIncompleteInit]);

  const [initInspectForm, setInitInspectForm] = useState({});

  useEffect(() => {
    if (editObj) {
      console.log("editObj trigger");
      setInitInspectForm(editObj); //reset initInspectForm to received editObj
    } else {
      console.log("initInspectForm initial state being set");
      setInitInspectForm({
        id: null,
        currentSection: currentSection, //pos 0, id 1
        vehicle_id: vehicleId,
        vehicle_start: "",
        alternator_charge: "",
        rough_idle: "",
        abnormal_noise: "",
        driving_belt: "",
        brake_noise: "",
        wheelBearing_noise: "",
        tireBalance_alignment: "",
        axle_noise: "",
        exhaust_leak: "",
        gauges: "",
        power_steering: "",
        transmission_shifting: "",
        cruise_control: "",
        brakePads_40: "",
        fourWheel_drive: "",
        roadTest_notes: "",

        //Exterior
        secondKey: "", //pos 19, id 20
        gas: "",
        tread_condition: "",
        lugNuts: "",
        antennaeMast: "",
        spareTireJackTools: "",
        highLowBeams: "",
        turnSignals: "",
        threeBrakeLights: "",
        reverseLights: "",
        tagLights: "",
        fogLights: "",
        wipersSprayers: "",
        exterior_notes: "",

        //Underhood
        battery: "", //id 34, pos 33
        oilChange: "",
        fluidsChecked: "",
        engineCover: "",
        underHood_notes: "",

        //interior
        windowsRoll: "", //id 39, pos 38
        doorLocks: "",
        powerSeats: "",
        ac_heater: "",
        ac_vents: "",
        cigaretteLighter: "",
        radio_speakers: "",
        sunroof: "",
        interiorDomeLights: "",
        windshield_crack: "",
        horn: "",
        power_mirrors: "",
        vanityMirrors_visors: "",
        seatBelts: "",
        fuelDoor: "",
        interiorPieces_present: "",
        emergencyBrake: "",
        cabinAirFilter: "",
        warningLights: "",
        interior_notes: "", //id 58, pos 57
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editObj]);

  const indexRanges = {
    11: { start: 3, end: 19 }, //edited from 3 to 2 ['.vehicle_start is in [2] position of initInspectForm
    12: { start: 20, end: 33 },
    13: { start: 34, end: 39 },
    14: { start: 40, end: 59 },
  };

  const clearSectionForm = (section) => {
    console.log("section value rec'd in clearSectionForm", section);
    if (section !== 11 && section !== 12 && section !== 13 && section !== 14) {
      return;
    }

    const { start, end } = indexRanges[section] || {};

    if (start !== undefined && end !== undefined) {
      const fields = Object.keys(initInspectForm);
      const newForm = { ...initInspectForm };

      for (let i = start; i <= end; i++) {
        const field = fields[i];
        if (field) {
          newForm[field] = i === end ? "" : "";
        }
      }
      //another issue its leaving vehicleStart populatted from 'toadtest somehow
      setInitInspectForm(newForm);
    }
  };

  const handleSelectChange = (field) => (params) => {
    const selectedOption = params.value[0] || null;
    setInitInspectForm((prevForm) => ({
      ...prevForm,
      [field]: selectedOption ? selectedOption.id : "", // Reset to default if cleared
    }));
  };

  const handleNotesChange = (field) => (params) => {
    const textValue = params.target.value; // Get the input value

    // Update the notes field with the user's input
    setInitInspectForm((prevForm) => ({
      ...prevForm,
      [field]: textValue, // No need to check for lastInitId here
    }));
  };

  let full_init = false;

  //////// SECTION SUBMIT FUNCTION (VehicleUpdateForm)
  const handleSectionSubmit = async (event, section, chosenSection) => {
    event.preventDefault(); // Prevent the default form submission behavior

    // if(lastInitId){ // if  received, we know we're submitting for a paused/existing init inspect obj, so we need to EDIT it instead.
    //   try {
    //     const response = await axios.post(
    //       `${apiUrl}/api/init_inspection/${initInspectForm.id}`,
    //       initInspectForm
    //     );
    //   } catch (error) {
    //     console.error("Error submitting form:", error);
    //     alert("error submittin changes");
    //   }
    // }

    full_init = true;
    let updatedCurrSect;

    if (section === 11) {
      updatedCurrSect = "roadtest";
    } else if (section === 12) {
      updatedCurrSect = "exterior";
    } else if (section === 13) {
      updatedCurrSect = "underhood";
    } else if (section === 14) {
      updatedCurrSect = "interior";
    }

    const updatedForm = {
      ...initInspectForm,
      currentSection: updatedCurrSect, // update init inspect obj 'currentSection'
    };

    console.log("updatedForm", updatedForm);

    try {
      const response = await axios.post(
        `${apiUrl}/api/initial_inspections`,
        updatedForm
      );
      //id value for new entry in initial_inspections
      const initInspectId = response.data.id;

      const sectionNotes =
        section === 11
          ? initInspectForm.roadTest_notes
          : section === 12
          ? initInspectForm.exterior_notes
          : section === 13
          ? initInspectForm.underHood_notes
          : /* section === 14
          ? */ initInspectForm.interior_notes;
      /*      : null; */
      handleSubmitClick(
        event,
        section,
        initInspectId,
        sectionNotes,
        chosenSection,
        full_init
      ); //actually the 'handleSubmitEdit' that was passed
      //CLEAR initInspectForm values here, except .vehicleId & .currentSection
      clearSectionForm(section);
    } catch (error) {
      // Handle the error case if the submission fails
      console.error("Error submitting form:", error);
    }

    console.log("initInspectForm after handleSectionSubmit", initInspectForm);

    if (section === 14) {
      setIsModalOpen(false);
    }
  };

  ///////////  HANDLE SECTION PAUSE (VehicleUpdateForm)
  const handleSectionPause = async (event, section) => {
    event.preventDefault();

    console.log("sent init section", section); //11
    console.log("sent currentSection", currentSection); // 'roadtest
    console.log("sent initInspectForm handleSectionPause", initInspectForm); //correct
    console.log("sent chosenSection", chosenSection[0].id); //3
    console.log("editObj", editObj); //undefined

    // Update initInspectForm with the new currentSection
    const updatedForm = {
      ...initInspectForm,
      currentSection: currentSection, // update init inspect obj 'currentSection'
    };

    console.log("initInspectForm (after currentSection reset)", updatedForm);

    try {
      // First API call to save the updated form
      const response = await axios.post(
        `${apiUrl}/api/initial_inspections`,
        updatedForm
      );

      // Extract the initInspectId from the response (assuming the API response contains it)
      const initInspectId = response.data.id; // Adjust according to actual API response structure
      console.log("initInspectId from API response:", initInspectId);

      // // Determine section notes based on currentSection
      const sectionNotes =
        currentSection === "roadtest"
          ? updatedForm.roadTest_notes
          : currentSection === "exterior"
          ? updatedForm.exterior_notes
          : currentSection === "underhood"
          ? updatedForm.underHood_notes
          : updatedForm.interior_notes; // You can further adjust this logic based on your requirements

      // Call handleSubmitClick with the required values
      handleSubmitClick(
        event,
        section,
        initInspectId,
        sectionNotes, // The notes related to the current section
        chosenSection[0].id,
        full_init //will still be false from above global declaration
      );
    } catch (error) {
      console.error("Error submitting form:", error);
    }

    // Close the modal after the operations are done
    clearSectionForm(section);
    setIsModalOpen(false);
  };

  // SECTION EDIT (EditInspectModal)
  const handleSectionEdit = async (event, chosenSection) => {
    event.preventDefault();
    console.log("chosenSection passed to handleSection Edit", chosenSection);
    console.log("lastInitId", lastInitId);
    console.log("initInspectForm in handleSectionEdit", initInspectForm);
    console.log("editObj", editObj);
    let newSection = chosenSection;

    ////////////// INITIAL_INSPECTIONS UPDATE (EDIT RECORD)
    try {
      const response = await axios.post(
        `${apiUrl}/api/init_inspection/${initInspectForm.id}`,
        initInspectForm
      );
      if(response.status === 200) console.log("Initial inspection updated successfully");
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Error submitting changes");
    }

    let sectionNotes;

    if (initInspectForm.currentSection === "roadtest") {
      sectionNotes = `ROADTEST, ${initInspectForm.roadTest_notes}`;
      newSection = 12;
    } else if (initInspectForm.currentSection === "exterior") {
      sectionNotes = `EXTERIOR, ${initInspectForm.exterior_notes}`;
      newSection = 13;
    } else if (initInspectForm.currentSection === "underhood") {
      sectionNotes = `UNDERHOOD, ${initInspectForm.underHood_notes}`;
      newSection = 14;
    } else {
      sectionNotes = `INTERIOR, ${initInspectForm.interior_notes}`;
    }

    // ////////////// INSPECTIONS UPDATE
    try {
      const response = await axios.post(
        `${apiUrl}/api/inspection_edit-init/${initInspectForm.id}`,
        { sectionNotes, newSection }
      );
      if(response.status === 200) console.log("Inspection updated successfully");
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Error submitting changes");
    }

    ////////////////////// INVENTORY UPDATE
    if (lastInitId) {
      try {
        const vehicleId = initInspectForm.vehicle_id; // Extract vehicle ID from the form data

        const updateData = {
          init_paused: currentSection === "interior" ? 0 : 1, // Only update the 'init_paused' field
          app_status: newSection,
        };

        // Make the PUT request to update 'init_paused' for the specific vehicle
        const updateInventoryResponse = await axios.put(
          `${apiUrl}/api/inventory/${vehicleId}`,
          updateData
        );

        if (updateInventoryResponse.status === 200) {
          alert("Vehicle 'init_paused' updated successfully");
        } else {
          alert("Failed to update vehicle 'init_paused'");
        }
      } catch (error) {
        console.error("Error updating 'init_paused':", error);
        alert("Error while updating 'init_paused'");
      }

      // Directly close the modal without an unnecessary arrow function
    }
    // setIsModalOpen(false);
    onClose();
    alert("Your inspection edits have been saved!");
  };

  return (
    <>
      {/*************** PAUSE INSPECTION DIV ***************/}
      {!editObj && (
        <div
          style={{
            backgroundColor: "lightblue",
            padding: ".75rem",
            paddingTop: ".25rem",
            borderRadius: ".5rem",
          }}
        >
          <h3 style={{ color: "black" }}>Pause Inspection and Send</h3>
          <Select
            options={filteredSteps}
            placeholder="Choose where to send"
            onChange={(selectedOption) => {
              const valueArray = filteredSteps.filter(
                (step) => step.id === selectedOption.value[0].id
              );
              setChosenSection(valueArray);
            }} //get a section name ot be assigned to 'nextStatus' in 'inspections'
            value={chosenSection}
          />
          <FormControl label="Describe reason for pause">
            <Textarea
              value={
                currentSection === "roadtest"
                  ? initInspectForm.roadTest_notes
                  : currentSection === "exterior"
                  ? initInspectForm.exterior_notes
                  : currentSection === "underhood"
                  ? initInspectForm.underHood_notes
                  : currentSection === "interior"
                  ? initInspectForm.interior_notes
                  : ""
              }
              onChange={
                currentSection === "roadtest"
                  ? handleNotesChange("roadTest_notes")
                  : currentSection === "exterior"
                  ? handleNotesChange("exterior_notes")
                  : currentSection === "underhood"
                  ? handleNotesChange("underHood_notes")
                  : currentSection === "interior"
                  ? handleNotesChange("interior_notes")
                  : null
              }
              placeholder="Enter notes"
            />
          </FormControl>
          <Button
            style={{
              backgroundColor: "lightcoral",
            }}
            onClick={(event) => {
              event.stopPropagation();

              handleSectionPause(
                event,
                currentSection === "roadtest"
                  ? 11
                  : currentSection === "exterior"
                  ? 12
                  : currentSection === "underhood"
                  ? 13
                  : currentSection === "interior"
                  ? 14
                  : null // Default value if none of the conditions are met
              );
            }}
          >
            Pause and Send
          </Button>{" "}
        </div>
      )}

      {currentSection === "roadtest" ? (
        editObj ? (
          <RoadtestSection
            initInspectForm={initInspectForm}
            handleSelectChange={handleSelectChange}
            handleNotesChange={handleNotesChange}
            clearSectionForm={clearSectionForm}
            handleSectionSubmit={handleSectionEdit} // Use edit handler when editObj exists
          />
        ) : (
          <RoadtestSection
            initInspectForm={initInspectForm}
            handleSelectChange={handleSelectChange}
            handleNotesChange={handleNotesChange}
            clearSectionForm={clearSectionForm}
            handleSectionSubmit={handleSectionSubmit} // Use default submit handler when editObj is absent
            handleSubmitClick={handleSubmitClick}
          />
        )
      ) : currentSection === "exterior" ? (
        editObj ? (
          <ExteriorSection
            initInspectForm={initInspectForm}
            handleSelectChange={handleSelectChange}
            handleNotesChange={handleNotesChange}
            clearSectionForm={clearSectionForm}
            handleSectionSubmit={handleSectionEdit} // Use edit handler for exterior section
          />
        ) : (
          <ExteriorSection
            initInspectForm={initInspectForm}
            handleSelectChange={handleSelectChange}
            handleNotesChange={handleNotesChange}
            clearSectionForm={clearSectionForm}
            handleSectionSubmit={handleSectionSubmit}
            handleSubmitClick={handleSubmitClick}
          />
        )
      ) : currentSection === "underhood" ? (
        editObj ? (
          <UnderhoodSection
            initInspectForm={initInspectForm}
            handleSelectChange={handleSelectChange}
            handleNotesChange={handleNotesChange}
            clearSectionForm={clearSectionForm}
            handleSectionSubmit={handleSectionEdit} // Use edit handler for underhood section
            setIsModalOpen={setIsModalOpen}
          />
        ) : (
          <UnderhoodSection
            initInspectForm={initInspectForm}
            handleSelectChange={handleSelectChange}
            handleNotesChange={handleNotesChange}
            clearSectionForm={clearSectionForm}
            handleSectionSubmit={handleSectionSubmit}
            handleSubmitClick={handleSubmitClick}
          />
        )
      ) : currentSection === "interior" ? (
        editObj ? (
          <InteriorSection
            initInspectForm={initInspectForm}
            handleSelectChange={handleSelectChange}
            handleNotesChange={handleNotesChange}
            clearSectionForm={clearSectionForm}
            handleSectionSubmit={handleSectionEdit} // Use edit handler for interior section
            setCurrentSection={setCurrentSection}
            filteredSteps={filteredSteps}
            setChosenSection={setChosenSection}
            chosenSection={chosenSection}
          />
        ) : (
          <InteriorSection
            initInspectForm={initInspectForm}
            handleSelectChange={handleSelectChange}
            handleNotesChange={handleNotesChange}
            clearSectionForm={clearSectionForm}
            handleSectionSubmit={handleSectionSubmit}
            setCurrentSection={setCurrentSection}
            filteredSteps={filteredSteps}
            setChosenSection={setChosenSection}
            chosenSection={chosenSection}
            handleSubmitClick={handleSubmitClick}
          />
        )
      ) : null}
    </>
  );
}

function RoadtestSection({
  initInspectForm,
  handleSelectChange,
  handleNotesChange,
  clearSectionForm,
  handleSectionSubmit,
}) {
  // Dynamically compute selected value for each field
  const getSelectedValue = (field) =>
    filteredOptions.find((option) => option.id === initInspectForm[field]) ||
    null;

  return (
    <>
      <h1>
        Initial Inspection: <span style={{ color: "blue" }}>Road Test</span>
      </h1>

      <FormControl label="Did the vehicle start with no problems?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("vehicle_start")
              ? [getSelectedValue("vehicle_start")]
              : []
          }
          onChange={handleSelectChange("vehicle_start")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Is the alternator charging the vehicle?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("alternator_charge")
              ? [getSelectedValue("alternator_charge")]
              : []
          }
          onChange={handleSelectChange("alternator_charge")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Does the vehicle have rough idle, or vibrations?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("rough_idle")
              ? [getSelectedValue("rough_idle")]
              : []
          }
          onChange={handleSelectChange("rough_idle")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Is the Engine making any abnormal noises?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("abnormal_noise")
              ? [getSelectedValue("abnormal_noise")]
              : []
          }
          onChange={handleSelectChange("abnormal_noise")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Is the Drive Belt making noise and in good shape?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("driving_belt")
              ? [getSelectedValue("driving_belt")]
              : []
          }
          onChange={handleSelectChange("driving_belt")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Are there any Brake noises and/or Vibrations?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("brake_noise")
              ? [getSelectedValue("brake_noise")]
              : []
          }
          onChange={handleSelectChange("brake_noise")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Does the vehicle have Wheel Bearing noises?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("wheelBearing_noise")
              ? [getSelectedValue("wheelBearing_noise")]
              : []
          }
          onChange={handleSelectChange("wheelBearing_noise")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="How is the Tire Balance and Alignment?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("tireBalance_alignment")
              ? [getSelectedValue("tireBalance_alignment")]
              : []
          }
          onChange={handleSelectChange("tireBalance_alignment")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Do the Axles make noise when turning?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("axle_noise")
              ? [getSelectedValue("axle_noise")]
              : []
          }
          onChange={handleSelectChange("axle_noise")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Is there an Exhaust Leak?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("exhaust_leak")
              ? [getSelectedValue("exhaust_leak")]
              : []
          }
          onChange={handleSelectChange("exhaust_leak")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Do all the gauges work?">
        <Select
          options={filteredOptions}
          value={getSelectedValue("gauges") ? [getSelectedValue("gauges")] : []}
          onChange={handleSelectChange("gauges")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Does the Power Steering work?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("power_steering")
              ? [getSelectedValue("power_steering")]
              : []
          }
          onChange={handleSelectChange("power_steering")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Does the Transmission Shift correctly?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("transmission_shifting")
              ? [getSelectedValue("transmission_shifting")]
              : []
          }
          onChange={handleSelectChange("transmission_shifting")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Does the Cruise Control work?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("cruise_control")
              ? [getSelectedValue("cruise_control")]
              : []
          }
          onChange={handleSelectChange("cruise_control")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Are the Brake Pads above 40%?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("brakePads_40")
              ? [getSelectedValue("brakePads_40")]
              : []
          }
          onChange={handleSelectChange("brakePads_40")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Does the Four Wheel Drive work?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("fourWheel_drive")
              ? [getSelectedValue("fourWheel_drive")]
              : []
          }
          onChange={handleSelectChange("fourWheel_drive")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Notes (Please address all 'needs attention' or mark n/a if none)">
        <Textarea
          value={initInspectForm.roadTest_notes || ""} // Access the notes field from initInspectForm
          onChange={handleNotesChange("roadTest_notes")}
          placeholder="Enter notes"
        />
      </FormControl>
      <Button
        style={{ marginRight: "1rem", marginBottom: "1rem" }}
        type="submit"
        onClick={(event) => {
          handleSectionSubmit(event, 11);
        }}
      >
        Submit Form
      </Button>
      <Button
        style={{ backgroundColor: "#ff6347", marginBottom: "1rem" }}
        onClick={() => clearSectionForm(11)}
      >
        Clear Form
      </Button>
    </>
  );
}

function ExteriorSection({
  initInspectForm,
  handleSelectChange,
  handleNotesChange,
  clearSectionForm,
  handleSectionSubmit,
  handleSubmitClick,
}) {
  const getSelectedValue = (field) =>
    filteredOptions.find((option) => option.id === initInspectForm[field]) ||
    null;

  return (
    <>
      <h1>
        Initial Inspection: <span style={{ color: "blue" }}>Exterior</span>
      </h1>
      <FormControl label="Does the vehicle need a second key? (No = 'Good',  Yes = 'Needs Attention')">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("secondKey") ? [getSelectedValue("secondKey")] : []
          }
          onChange={handleSelectChange("secondKey")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Does the vehicle have gas? (Yes = 'Good',  No = 'Needs Attention')">
        <Select
          options={filteredOptions}
          value={getSelectedValue("gas") ? [getSelectedValue("gas")] : []}
          onChange={handleSelectChange("gas")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="How is the tiretread?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("tread_condition")
              ? [getSelectedValue("tread_condition")]
              : []
          }
          onChange={handleSelectChange("tread_condition")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Are all of the lug nuts present?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("lugNuts") ? [getSelectedValue("lugNuts")] : []
          }
          onChange={handleSelectChange("lugNuts")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Is the antenna mast present?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("antennaeMast")
              ? [getSelectedValue("antennaeMast")]
              : []
          }
          onChange={handleSelectChange("antennaeMast")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Is the Spare tire, jack, and tools present?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("spareTireJackTools")
              ? [getSelectedValue("spareTireJackTools")]
              : []
          }
          onChange={handleSelectChange("spareTireJackTools")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="High beams and low beams working?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("highLowBeams")
              ? [getSelectedValue("highLowBeams")]
              : []
          }
          onChange={handleSelectChange("highLowBeams")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Are all the Turn Signals Working?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("turnSignals")
              ? [getSelectedValue("turnSignals")]
              : []
          }
          onChange={handleSelectChange("turnSignals")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Do all three Brake Lights work?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("threeBrakeLights")
              ? [getSelectedValue("threeBrakeLights")]
              : []
          }
          onChange={handleSelectChange("threeBrakeLights")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Do the Reverse Lights work?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("reverseLights")
              ? [getSelectedValue("reverseLights")]
              : []
          }
          onChange={handleSelectChange("reverseLights")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Do the Tag Lights Work?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("tagLights") ? [getSelectedValue("tagLights")] : []
          }
          onChange={handleSelectChange("tagLights")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Do the Fog Lights Work?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("fogLights") ? [getSelectedValue("fogLights")] : []
          }
          onChange={handleSelectChange("fogLights")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Are the Wipers in good condition and the Sprayers Working?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("wipersSprayers")
              ? [getSelectedValue("wipersSprayers")]
              : []
          }
          onChange={handleSelectChange("wipersSprayers")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Notes (Please address all 'needs attention' or mark n/a if none)">
        <Textarea
          value={initInspectForm.exterior_notes || ""} // Access the notes field from initInspectForm
          onChange={handleNotesChange("exterior_notes")}
          placeholder="Enter notes"
        />
      </FormControl>
      <Button
        style={{ marginRight: "1rem", marginBottom: "1rem" }}
        type="submit"
        //         onClick={handleSectionSubmit}
        onClick={(event) => handleSectionSubmit(event, 12)}
      >
        Submit Form
      </Button>
      <Button
        style={{ backgroundColor: "#ff6347", marginBottom: "1rem" }}
        onClick={() => clearSectionForm(12)}
      >
        Clear Form
      </Button>
    </>
  );
}

function UnderhoodSection({
  initInspectForm,
  handleSelectChange,
  handleNotesChange,
  clearSectionForm,
  handleSectionSubmit,
}) {
  const getSelectedValue = (field) =>
    filteredOptions.find((option) => option.id === initInspectForm[field]) ||
    null;

  return (
    <>
      <h1>
        {" "}
        Initial Inspection: <span style={{ color: "blue" }}>Underhood</span>
      </h1>

      <FormControl label="Is the batterty good? (Yes = 'Good',  No = 'Needs Attention')">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("battery") ? [getSelectedValue("battery")] : []
          }
          onChange={handleSelectChange("battery")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Oil change completed?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("oilChange") ? [getSelectedValue("oilChange")] : []
          }
          onChange={handleSelectChange("oilChange")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Checked all of the fluids?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("fluidsChecked")
              ? [getSelectedValue("fluidsChecked")]
              : []
          }
          onChange={handleSelectChange("fluidsChecked")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Engine Covers?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("engineCover")
              ? [getSelectedValue("engineCover")]
              : []
          }
          onChange={handleSelectChange("engineCover")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Notes (Please address all 'needs attention' or mark n/a if none)">
        <Textarea
          value={initInspectForm.underHood_notes || ""} // Access the notes field from initInspectForm
          onChange={handleNotesChange("underHood_notes")}
          placeholder="Enter notes"
        />
      </FormControl>
      <Button
        style={{ marginRight: "1rem", marginBottom: "1rem" }}
        type="submit"
        //         onClick={handleSectionSubmit}
        onClick={(event) => handleSectionSubmit(event, 13)}
      >
        Submit Form
      </Button>
      <Button
        style={{ backgroundColor: "#ff6347", marginBottom: "1rem" }}
        onClick={() => clearSectionForm(13)}
      >
        Clear Form
      </Button>
    </>
  );
}

function InteriorSection({
  initInspectForm,
  handleSelectChange,
  handleNotesChange,
  clearSectionForm,
  filteredSteps,
  setChosenSection,
  chosenSection,
  handleSectionSubmit,
}) {
  const getSelectedValue = (field) =>
    filteredOptions.find((option) => option.id === initInspectForm[field]) ||
    null;

  console.log("chosenSection", chosenSection);
  return (
    <>
      <h1>
        {" "}
        Initial Inspection: <span style={{ color: "blue" }}>Interior</span>
      </h1>

      <FormControl label="Do ALL the Windows roll up and down?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("windowsRoll")
              ? [getSelectedValue("windowsRoll")]
              : []
          }
          onChange={handleSelectChange("windowsRoll")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Do ALL of the door locks work?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("doorLocks") ? [getSelectedValue("doorLocks")] : []
          }
          onChange={handleSelectChange("doorLocks")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Do ALL of the Power Seats work?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("powerSeats")
              ? [getSelectedValue("powerSeats")]
              : []
          }
          onChange={handleSelectChange("powerSeats")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Does the A/C and Heater work?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("ac_heater") ? [getSelectedValue("ac_heater")] : []
          }
          onChange={handleSelectChange("ac_heater")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Does the A/C blow through all the different vents?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("ac_vents") ? [getSelectedValue("ac_vents")] : []
          }
          onChange={handleSelectChange("ac_vents")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Does the Cigarette Lighter work?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("cigaretteLighter")
              ? [getSelectedValue("cigaretteLighter")]
              : []
          }
          onChange={handleSelectChange("cigaretteLighter")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Does the Radio and All the Speakers Working?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("radio_speakers")
              ? [getSelectedValue("radio_speakers")]
              : []
          }
          onChange={handleSelectChange("radio_speakers")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Is the Sunroof Operational?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("sunroof") ? [getSelectedValue("sunroof")] : []
          }
          onChange={handleSelectChange("sunroof")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Does all the Interior Dome Lights work?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("interiorDomeLights")
              ? [getSelectedValue("interiorDomeLights")]
              : []
          }
          onChange={handleSelectChange("interiorDomeLights")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Is the Windsheild Cracked?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("windshield_crack")
              ? [getSelectedValue("windshield_crack")]
              : []
          }
          onChange={handleSelectChange("windshield_crack")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Does the horn work?">
        <Select
          options={filteredOptions}
          value={getSelectedValue("horn") ? [getSelectedValue("horn")] : []}
          onChange={handleSelectChange("horn")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Does all the Power Mirrors work?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("power_mirrors")
              ? [getSelectedValue("power_mirrors")]
              : []
          }
          onChange={handleSelectChange("power_mirrors")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Inspected both Vanity Mirrors and Visors?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("vanityMirrors_visors")
              ? [getSelectedValue("vanityMirrors_visors")]
              : []
          }
          onChange={handleSelectChange("vanityMirrors_visors")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="All Seat belts Work?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("seatBelts") ? [getSelectedValue("seatBelts")] : []
          }
          onChange={handleSelectChange("seatBelts")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Does the Fuel Door Release Work?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("fuelDoor") ? [getSelectedValue("fuelDoor")] : []
          }
          onChange={handleSelectChange("fuelDoor")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Are all the pieces of the Interior present and in good shape?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("interiorPieces_present")
              ? [getSelectedValue("interiorPieces_present")]
              : []
          }
          onChange={handleSelectChange("interiorPieces_present")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Does the Parking Brake work?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("emergencyBrake")
              ? [getSelectedValue("emergencyBrake")]
              : []
          }
          onChange={handleSelectChange("emergencyBrake")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Condition of Cabin Air Filter">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("cabinAirFilter")
              ? [getSelectedValue("cabinAirFilter")]
              : []
          }
          onChange={handleSelectChange("cabinAirFilter")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Are there any lights on in the dash?">
        <Select
          options={filteredOptions}
          value={
            getSelectedValue("warningLights")
              ? [getSelectedValue("warningLights")]
              : []
          }
          onChange={handleSelectChange("warningLights")}
          clearable
          placeholder="Select an option"
        />
      </FormControl>
      <FormControl label="Notes (Please address all 'needs attention' or mark n/a if none)">
        <Textarea
          value={initInspectForm.interior_notes || ""} // Access the notes field from initInspectForm
          onChange={handleNotesChange("interior_notes")}
          placeholder="Enter notes"
        />
      </FormControl>
      <FormControl label="Where is vehicle going next?">
        <Select
          options={filteredSteps}
          placeholder="Select Next Step"
          onChange={(selectedOption) => {
            // console.log("selectedOption", selectedOption.value[0].id);

            const valueArray = filteredSteps.filter(
              (step) => step.id === selectedOption.value[0].id
            );
            console.log("valueArray", valueArray);
            // setChosenSection(selectedOption.value[0].id);
            setChosenSection(valueArray);
          }} //get a section name ot be assigned to 'nextStatus' in 'inspections'
          value={chosenSection}
        />
      </FormControl>
      <Button
        style={{ marginRight: "1rem", marginBottom: "1rem" }}
        type="submit"
        //         onClick={handleSectionSubmit}
        onClick={(event) => handleSectionSubmit(event, 14, chosenSection[0].id)}
      >
        Submit Form
      </Button>
      <Button
        style={{ backgroundColor: "#ff6347", marginBottom: "1rem" }}
        onClick={() => clearSectionForm(4)}
      >
        Clear Form
      </Button>
    </>
  );
}
